import appSettings from 'wanderu-config';
import { i18nMoment } from 'wanderu-i18n';
import { SnowplowService } from 'wanderu-service-analytics';
import {
    isLocalStorageAvailable,
} from 'wanderu-utils';

function normalizeDates(departDate, returnDate) {
    if (!departDate) {
        return {
            departDate: undefined,
            returnDate: undefined,
        };
    }

    const now = i18nMoment().startOf('day');
    const momentDepartDate = i18nMoment(departDate);
    const momentReturnDate = i18nMoment(returnDate);

    if (momentDepartDate.isBefore(now)) {
        return {
            departDate: undefined,
            returnDate: undefined,
        };
    }

    if (returnDate && momentReturnDate.isBefore(momentDepartDate)) {
        return {
            departDate,
            returnDate: undefined,
        };
    }

    return {
        departDate,
        returnDate,
    };
}

function getDefaultDate() {
    return i18nMoment().format();
}

function shouldShowPricing(currency) {
    return currency.toUpperCase() === 'USD';
}

function getLocalStorageSearchHistory(key) {
    if (!isLocalStorageAvailable() || !key) {
        return;
    }

    const history = JSON.parse(window.localStorage.getItem(key));

    if (!history) {
        return;
    }

    const now = i18nMoment();
    const momentExpiresAt = i18nMoment(history.expiresAt);
    if (now.isAfter(momentExpiresAt)) {
        window.localStorage.removeItem(key);
        return;
    }

    const {
        expiresAt: _expiresAt,
        createdAt: _createdAt,
        ...searchHistory
    } = history;

    let {
        departDate,
        returnDate,
        ...searchHistoryWithoutDates
    } = searchHistory;

    const {
        departDate: normalizedDepartDate,
        returnDate: normalizedReturnDate,
    } = normalizeDates(departDate, returnDate);

    if (!departDate) {
        return searchHistoryWithoutDates;
    }

    return {
        ...searchHistory,
        departDate: normalizedDepartDate,
        returnDate: normalizedReturnDate,
    };
}

function setLocalStorageSearchHistory(key, searchHistory) {
    if (!isLocalStorageAvailable() || !key) {
        return;
    }

    window.localStorage.setItem(key, JSON.stringify(searchHistory));
}

function getPredictionMetadata() {
    if (!appSettings.env.isClient) {
        return;
    }

    const domainData = SnowplowService.getDomainUserInfo();
    return {
        spdu_id: domainData.domainUserId,
        spds_id: domainData.domainSessionId,
        spds_idx: domainData.domainSessionIdx,
    };
}

export {
    getDefaultDate,
    getLocalStorageSearchHistory,
    getPredictionMetadata,
    normalizeDates,
    setLocalStorageSearchHistory,
    shouldShowPricing,
};
